<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Clearfix</h1>
        <p>Quickly and easily clear floated content within a container by adding a clearfix utility.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            <pre class="code-sample">
              <code class="html">
&lt;div class="clearfix"&gt; ... &lt;/div&gt;</code>
            </pre>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Variants / Modifiers</p>
            <p>Easily clear floats by adding <span class="code">.clearfix</span> to the parent element. Can also be used as a mixin.</p>
          </div>
        </div>
       <!--  <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Accessibility</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi ad doloremque rem quasi voluptatum temporibus voluptates non unde, veritatis molestias velit impedit iste tenetur officiis et quae nisi facilis atque!</p>
          </div>
        </div> -->
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Clearfix"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Clearfix.vue